import React from 'react'
import {Stack} from '@mui/material'
import WbOutlineButton from '../../../components/common/WbOutlineButton'
import {Emoji} from 'emoji-picker-react'
import ChangeQuestion from './ChangeQuestion'

export default function Question({question, setQuestion}) {
  const [openChange, setOpenChange] = React.useState(false)

  return (
    <div className="checkin-question-block">
      <Stack
        direction="column"
        mt={2}
        mb={3}
        justifyContent="center"
        alignItems="center"
      >
        <div className="checkin-question-item">{question?.pupilText}</div>
        <div className="answers">
          {question?.multiOptionResponseAttributes?.map((option, index) => (
            <div key={index} className="answer-item">
              <span>
                <Emoji unified={option?.pupilEmoji} size={64} />
              </span>
              {option?.pupilText}
            </div>
          ))}
        </div>
      </Stack>
      <div className="edit-question">
        {openChange && (
          <ChangeQuestion
            onClose={() => setOpenChange(false)}
            question={{
              ...question,
              multiOptionResponseAttributes: [
                ...question.multiOptionResponseAttributes,
              ],
            }}
            setQuestion={setQuestion}
          />
        )}
        <WbOutlineButton
          CustomOutlineButtonText={'Edit Question'}
          onClick={e => setOpenChange(true)}
        />
      </div>
    </div>
  )
}
